









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class Topmain extends Vue {
  panel: null | number = null;
  closePanel() {
    this.panel = null;
  }
  openPanel() {
    this.panel = this.panel == null ? 0 : null;
  }
}
